import { apiCall } from "./Interceptor";

const BID_CONSUMER_PLACE = "/bidding/consumer/place";
const BIDS_RECEIVED_CONSUMER = "/bidding/consumer/received";
const BIDS_LIST = "/bidding/consumer/placedAgainstGenerator"
const BIDS_RECEIVED = "/bidding/consumer/consumer-capacity-bid-details"
const UPDATE_STATUS = "/bidding/consumer/updateStatus";
const CONNECTION_DETAILS = "/bidding/consumer/bid-comparison";
const BIDS_PLACED_CONSUMER ="/bidding/consumer/bid-placed";
const PUSH_TRADE_CONNECT_CONSUMER = "/bidding/consumer/push-trade-connect";

const placeBidConsumer = async (data) => {
    const response = await apiCall.post(BID_CONSUMER_PLACE,data);
    return response;
}

const getReceivedBidsConsumer = async (id,history) => {
    const response = await apiCall.get(`${BIDS_RECEIVED_CONSUMER}?capacityId=${id}&isHistory=${history}`);
    return response;
}
const getPlacedBidsConsumer = async (id) => {
    const response = await apiCall.get(`${BIDS_PLACED_CONSUMER}?capacityId=${id}`);
    return response;
}
const getBidsListByGenCapacityId = async (genId,conId) => {
    const response = await apiCall.get(`${BIDS_LIST}?capacityConsumerId=${conId}&capacityGeneratorId=${genId}`);
    return response;
}

const getReceivedBidsListByConCapacityId = async (conCapId,bidId) => {
    const response = await apiCall.get(`${BIDS_RECEIVED}?consumerCapacityId=${conCapId}&bidId=${bidId}`);
    return response;
}

const updateConnectionStatus = async (data) => {
    const response = await apiCall.patch(UPDATE_STATUS,data);
    return response;
}

const getConnectionDetails = async (conId,genId) => {
    const response = await apiCall.get(`${CONNECTION_DETAILS}?capacityConsumerId=${conId}&capacityGeneratorId=${genId}`);
    return response;
}

const pushToTradeConnectFromConRole = async (data) => {
    const response = await apiCall.put(PUSH_TRADE_CONNECT_CONSUMER,data);
    return response;
}

export default {
    placeBidConsumer,
    getReceivedBidsConsumer,
    getBidsListByGenCapacityId,
    getReceivedBidsListByConCapacityId,
    updateConnectionStatus,
    getConnectionDetails,
    getPlacedBidsConsumer,
    pushToTradeConnectFromConRole,
};
